import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function ScheduledOrderCancelIcon(props) {
  return (
    <SvgIcon viewBox="0 0 61 60" {...props}>
      <title>Scheduled Order Cancel</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.9236 27.5L52.6282 28.2069L55.1137 30.6924L55.8184 31.3948V31.3971L55.1137 32.1017L45.9643 41.2489L55.8184 51.1029V51.1074L55.1137 51.8099L52.6282 54.2931L51.9236 55L42.0695 45.1459L32.2154 55L31.5107 54.2931L29.0253 51.8099L28.3184 51.1052L29.0253 50.3983L38.1747 41.2489L29.0253 32.1017L28.3184 31.3971L32.2154 27.5L32.9223 28.2069L42.0695 37.3541L51.2166 28.2069L51.9236 27.5ZM16.2343 5V9.24932H32.9002V5H37.0684V9.24932H39.1502C41.4447 9.24932 43.3184 11.1605 43.3184 13.5009V30.4868L41.3507 32.4938L39.1502 30.2539V19.876H9.98428V43.2507H30.8049L26.6368 47.5H9.98428C7.67187 47.5 5.81836 45.5866 5.81836 43.2507L5.83851 13.5009C5.83851 11.1605 7.67187 9.24932 9.98428 9.24932H12.0684V5H16.2343Z"
        />
      </g>
    </SvgIcon>
  );
}

export default ScheduledOrderCancelIcon;
